import { Pipe, PipeTransform } from '@angular/core';

import { Folder } from '../../main-module/declarations/folder';
import { normalizeText } from '../utils/text.utils';

import { SearchPipe } from './search.pipe';

@Pipe({
    name: 'folderContains',
    standalone: false
})
export class FolderContainsPipe implements PipeTransform {

  private searchPipeForNewsletters = new SearchPipe();

  transform(array: Folder[], name: string): Folder[] {

    if (name) {

      const normalizedName = normalizeText(name);
      return array.filter((folder) => {
        return normalizeText(folder.name).includes(normalizedName)
          || this.searchPipeForNewsletters.transform(folder.items, normalizedName, 'displayName').length > 0
          || this.transform(folder.folders, normalizedName).length > 0;
      });
    } else {
      return array;
    }
  }

}
